import { combineReducers } from '@reduxjs/toolkit';
import updateReducer from './features/filter/filterSlice';
import updateTransaction from './features/filter/transactionSlice';
import alertsFilterReducer from './features/filter/alertsFilterSlice';
import selectedTransactionReducer from './features/selectedTransaction/selectedTransactionSlice';

export const rootReducer = combineReducers({
  filter: updateReducer,
  transaction: updateTransaction,
  alertsFilter: alertsFilterReducer,
  selectedTransaction: selectedTransactionReducer,
});

export default rootReducer;
